<template>
    <b-list-group>
        <b-list-group-item>
            <b-form-checkbox
                class="float-right"
                id="checkbox-expandedList"
                v-model="expandedList"
                name="checkbox-expandedList"
                :value="true"
                :unchecked-value="false"
            >
                Expand
            </b-form-checkbox>
            <b-button-group size="sm">
                <b-button
                    v-show="permissionGroups.length > 0"
                    variant="primary"
                    @click="doCheckAll(true)"
                    >Check All</b-button
                >
                <b-button
                    v-show="permissionGroups.length > 0"
                    variant="warning"
                    @click="doCheckAll(false)"
                    >Uncheck All</b-button
                >
            </b-button-group>
        </b-list-group-item>
        <b-list-group-item>
            <b-row>
                <b-col cols="2"><h6>No</h6></b-col>
                <b-col><h6>Section</h6></b-col>
                <b-col cols="1"> <h6>Create</h6></b-col>
                <b-col cols="1"> <h6>View</h6></b-col>
                <b-col cols="1"> <h6>Update</h6></b-col>
                <b-col cols="1"> <h6>Delete</h6></b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item
            v-for="(item, idx) in permissionGroups"
            :key="`section--${idx}`"
        >
            <b-row>
                <b-col cols="2">{{ idx + 1 }}</b-col>
                <b-col> {{ item.section | formatSlug }}</b-col>
                <b-col cols="1">
                    <b-form-checkbox
                        @change="setPermission(idx, 'create', $event)"
                        :id="`create-${idx}`"
                        v-model="item.actions['create']"
                        name="checkbox-1"
                        :value="true"
                        :unchecked-value="false"
                    >
                    </b-form-checkbox>
                </b-col>
                <b-col cols="1">
                    <b-form-checkbox
                        @change="setPermission(idx, 'view', $event)"
                        :id="`view-${idx}`"
                        v-model="item.actions['view']"
                        name="checkbox-1"
                        :value="true"
                        :unchecked-value="false"
                    >
                    </b-form-checkbox>
                </b-col>
                <b-col cols="1">
                    <b-form-checkbox
                        @change="setPermission(idx, 'update', $event)"
                        :id="`update-${idx}`"
                        v-model="item.actions['update']"
                        name="checkbox-1"
                        :value="true"
                        :unchecked-value="false"
                    >
                    </b-form-checkbox>
                </b-col>
                <b-col cols="1">
                    <b-form-checkbox
                        @change="setPermission(idx, 'delete', $event)"
                        :id="`delete-${idx}`"
                        v-model="item.actions['delete']"
                        name="checkbox-1"
                        :value="true"
                        :unchecked-value="false"
                    >
                    </b-form-checkbox>
                </b-col>
            </b-row>
        </b-list-group-item>
    </b-list-group>
</template>
<script>
import { capitalCase } from 'change-case'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'PermissionGroups',
    data() {
        return {
            permissionGroups: [],
            expandedList: false,
        }
    },
    props: ['value'],
    mixins: [permissionsMixins],
    filters: {
        formatSlug(slug) {
            return capitalCase(slug.split('.').join('-'))
        },
    },
    computed: {
        permissions_list() {
            return this.$store.state.permissions.permissions_list
        },
    },
    watch: {
        value: {
            handler: function (val) {
                console.log('watch---value', val)
                this.setModel(val)
            },
            deep: true,
        },
        expandedList: function () {
            this.setModel(this.value)
        },
        permissions_list: {
            handler: function () {
                this.$nextTick(() => {
                    this.updateValues()
                })
            },
            deep: true,
        },
    },
    mounted() {
        console.log('mounted---value', this.value)
        this.setModel(this.value)
        console.log('mounted---permissions_list', this.permissions_list)
    },
    methods: {
        async createPermissionIfNotExists(action, section) {
            const slug = `${action}.${section}`
            console.log('slug', slug)
            const permission = this.permissions_list.find(x => x.slug === slug)
            if (permission) {
                return true
            } else {
                const name = capitalCase(action)
                section = capitalCase(section.split('.').join(' '))
                await this.$store.dispatch('permissions/create', {
                    name,
                    section,
                })
                return false
            }
        },

        async setPermission(idx, action) {
            const group = this.permissionGroups[idx]
            const alreadyExists = await this.createPermissionIfNotExists(
                action,
                group.section
            )
            if (alreadyExists) this.updateValues()
        },

        updateValues() {
            let values = []
            for (let value of this.permissionGroups) {
                //const object = { a: 1, b: 2, c: 3 };
                for (let actionKey in value.actions) {
                    //for (const property in object) {
                    console.log()
                    if (value.actions[actionKey]) {
                        const slug = `${actionKey}.${value.section}`
                            .split(' ')
                            .join('.')
                            .toLowerCase()
                        const option = this.permissions_list.find(
                            x => x.slug === slug
                        )
                        if (!option) throw new Error('Option not Found!')
                        const name = option.name
                        values.push({
                            name,
                            slug,
                        })
                    }
                }
            }
            console.log('new permission permissionGroups', values)
            this.$emit('input', values)
        },

        async doCheckAll(selected) {
            const $this = this
            for (let i = 0; i < this.permissionGroups.length; i++) {
                const { section } = this.permissionGroups[i]
                const actions = {
                    create: selected,
                    view: selected,
                    update: selected,
                    delete: selected,
                }
                await Promise.all(
                    ['create', 'view', 'update', 'delete'].map(x =>
                        $this.createPermissionIfNotExists(x, section)
                    )
                )
                this.$set($this.permissionGroups, i, { section, actions })
            }
            this.updateValues()
        },

        setModel(values) {
            const _groupedSections = (values || []).reduce((_list, x) => {
                const parts = x.slug.split('.')
                const action = parts[0]
                const section = parts.slice(1).join('.')
                const idx = _list.findIndex(x => x.section === section)
                if (idx < 0) {
                    const actions = {
                        create: false,
                        update: false,
                        delete: false,
                        view: false,
                    }
                    actions[action] = true
                    _list.push({
                        section,
                        actions,
                    })
                } else {
                    const obj = _list[idx]
                    obj.actions[action] = true
                    _list.splice(idx, 1, obj)
                }
                return _list
            }, [])

            const slugSections = this.permissionSections.map(x =>
                x.split(' ').join('.').toLowerCase()
            )
            const _cleanGroupedSections = slugSections.map(section => {
                const _groupSection = _groupedSections.find(
                    _group => _group.section === section
                )
                if (_groupSection) {
                    return _groupSection
                }

                const actions = {
                    create: false,
                    update: false,
                    delete: false,
                    view: false,
                }

                return {
                    section,
                    actions,
                }
            })

            _cleanGroupedSections.sort((a, b) => {
                if (a.section > b.section) return 1
                else if (b.section > a.section) return -1
                else return 0
            })

            const isExpanded = this.expandedList
            this.permissionGroups = _cleanGroupedSections.filter(x => {
                if (isExpanded) return true
                else {
                    let allFalse = false
                    for (let prop in x.actions) {
                        allFalse = allFalse || x.actions[prop]
                    }
                    return allFalse
                }
            })
        },
    },
}
</script>
